module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "redstone-logo.315042f7.svg";